import {styled} from "@mui/system";
import {Paper} from "@mui/material";

const Card = styled(Paper)(({theme}) => ({
  ...theme.paper.paper,
  margin: "1rem",
}));

export default Card;